import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBigLogoCp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 300,
	height: 320,
	viewBox: "0 0 300 320",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0 20C0 8.95431 8.95431 0 20 0H300V320H20C8.9543 320 0 311.046 0 300V20Z",
			fill: "#001C20",
			fillOpacity: .8
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_16421_141)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M81.3642 149.244H73.1266V158.058H80.2227V162.532H73.1266V171.824H81.3642V176.297H68.1992V144.789H81.3642V149.263V149.244Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M85.7207 144.789H91.1427L94.2627 155.324L97.3828 144.789H102.805L96.9452 159.97L103.28 176.297H97.8584L94.2437 164.922L90.629 176.297H85.207L91.409 159.97L85.6826 144.789H85.7207Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M116.064 144.789C121.752 144.789 124.13 147.791 124.13 154.387C124.13 160.983 121.752 163.946 116.064 163.946H113.115V176.297H108.188V144.789H116.064ZM113.115 149.244V159.473H115.892C118.537 159.473 119.203 157.561 119.203 154.387C119.203 151.213 118.537 149.244 115.892 149.244H113.115Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M131.627 173.946C129.553 171.422 129.344 168.019 129.344 160.544C129.344 153.068 129.572 149.665 131.627 147.141C132.901 145.592 134.804 144.445 137.696 144.445C140.587 144.445 142.49 145.592 143.764 147.141C145.876 149.627 146.047 153.068 146.047 160.544C146.047 168.019 145.876 171.48 143.764 173.946C142.49 175.495 140.587 176.642 137.696 176.642C134.804 176.642 132.901 175.495 131.627 173.946ZM140.074 170.983C141.006 169.472 141.139 166.299 141.139 160.544C141.139 154.789 141.006 151.596 140.074 150.105C139.636 149.397 138.894 148.919 137.696 148.919C136.497 148.919 135.793 149.397 135.356 150.105C134.423 151.615 134.252 154.789 134.252 160.544C134.252 166.299 134.423 169.491 135.356 170.983C135.793 171.69 136.497 172.168 137.696 172.168C138.894 172.168 139.636 171.69 140.074 170.983Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M164.995 146.415C166.631 148.002 167.202 150.258 167.202 153.279H162.274C162.274 151.864 162.179 150.755 161.532 149.914C161.095 149.341 160.391 148.977 159.326 148.977C158.26 148.977 157.689 149.341 157.214 149.857C156.643 150.526 156.377 151.578 156.377 152.954C156.377 155.516 156.776 156.319 158.983 157.199L162.674 158.709C166.422 160.258 167.43 162.246 167.43 167.561C167.43 170.792 166.992 172.953 165.394 174.501C164.12 175.744 162.046 176.585 159.269 176.585C156.491 176.585 154.512 175.84 153.2 174.501C151.697 172.991 151.164 171.041 151.164 167.733H156.091C156.091 169.416 156.263 170.486 156.967 171.27C157.404 171.748 158.146 172.112 159.25 172.112C160.353 172.112 161.152 171.806 161.628 171.232C162.293 170.486 162.465 169.416 162.465 167.733C162.465 164.368 161.932 163.527 159.516 162.552L155.768 161.003C152.591 159.684 151.411 157.944 151.411 153.088C151.411 150.258 152.248 147.945 153.961 146.396C155.33 145.211 157.081 144.484 159.326 144.484C161.837 144.484 163.682 145.154 164.957 146.396L164.995 146.415Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M189.235 168.496C189.235 170.886 188.493 172.875 187.085 174.29C185.582 175.838 183.641 176.641 181.263 176.641C178.885 176.641 176.907 175.838 175.404 174.29C173.996 172.875 173.254 170.886 173.254 168.496V144.77H178.181V168.305C178.181 170.963 179.285 172.148 181.263 172.148C183.242 172.148 184.307 170.963 184.307 168.305V144.77H189.235V168.496Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M203.941 144.789C209.667 144.789 211.95 147.58 211.95 154.081C211.95 157.981 211.151 160.773 208.298 162.321L212.959 176.297H207.803L203.713 163.373H200.935V176.297H196.008V144.789H203.941ZM200.954 149.244V158.899H203.998C206.643 158.899 207.042 156.681 207.042 154.081C207.042 151.481 206.643 149.263 203.998 149.263H200.954V149.244Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M232.001 149.244H223.763V158.058H230.859V162.532H223.763V171.824H232.001V176.297H218.836V144.789H232.001V149.263V149.244Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M78.6642 200.789H77.1994V186.488L73.9652 195.875H72.8998L69.7227 186.794V200.789H68.2578V183.027H69.7227L73.4515 193.486L77.1994 183.027H78.6642V200.789Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M86.7498 183.027L90.6688 200.789H89.1088L88.1386 195.933H83.9912L83.021 200.789H81.4609L85.38 183.027H86.7498ZM86.0459 185.685L84.2575 194.614H87.8532L86.0459 185.685Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M101.322 200.789H99.8761L94.9297 186.947V200.789H93.4648V183.027H94.9297L99.8381 196.87V183.027H101.303V200.789H101.322Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M109.406 183.027L113.325 200.789H111.765L110.795 195.933H106.647L105.677 200.789H104.117L108.036 183.027H109.406ZM108.721 185.685L106.933 194.614H110.528L108.721 185.685Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M121.981 183.813C122.742 184.616 123.046 185.725 123.065 187.101H121.6C121.6 185.687 121.182 184.157 119.393 184.157C118.727 184.157 118.195 184.387 117.833 184.807C117.11 185.648 116.996 186.719 116.996 191.919C116.996 197.12 117.129 198.171 117.833 199.032C118.214 199.452 118.727 199.682 119.393 199.682C120.687 199.682 121.6 198.707 121.6 197.005V192.646H119.393V191.403H123.065V197.005C123.065 199.682 121.353 201.001 119.393 201.001C118.233 201.001 117.358 200.619 116.768 199.95C115.702 198.802 115.531 197.56 115.531 191.919C115.531 186.279 115.702 185.037 116.768 183.889C117.358 183.22 118.233 182.838 119.393 182.838C120.554 182.838 121.372 183.22 121.981 183.813Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M133.262 184.366H128.563V191.096H132.615V192.415H128.563V199.47H133.262V200.789H127.098V183.027H133.262V184.347V184.366Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M147.551 200.789H146.086V186.488L142.852 195.875H141.787L138.609 186.794V200.789H137.145V183.027H138.609L142.338 193.486L146.086 183.027H147.551V200.789Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M158.129 184.366H153.43V191.096H157.482V192.415H153.43V199.47H158.129V200.789H151.965V183.027H158.129V184.347V184.366Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M169.845 200.789H168.4L163.453 186.947V200.789H161.988V183.027H163.453L168.362 196.87V183.027H169.826V200.789H169.845Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M180.464 184.366H177.515V200.809H176.05V184.366H173.102V183.047H180.483V184.366H180.464Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M99.0737 109.23V109.191C99.0737 106.304 101.243 103.934 104.344 103.934C106.246 103.934 107.387 104.565 108.32 105.501L106.912 107.146C106.132 106.438 105.333 105.998 104.324 105.998C102.612 105.998 101.395 107.413 101.395 109.153V109.191C101.395 110.931 102.593 112.384 104.324 112.384C105.485 112.384 106.189 111.925 106.988 111.199L108.396 112.633C107.349 113.742 106.208 114.449 104.248 114.449C101.281 114.449 99.0547 112.136 99.0547 109.23H99.0737Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M110.223 104.125H112.449V108.14H116.558V104.125H118.784V114.277H116.558V110.205H112.449V114.277H110.223V104.125Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M121.429 104.125H129.058V106.113H123.636V108.178H128.392V110.167H123.636V112.308H129.115V114.296H121.41V104.144L121.429 104.125Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M130.695 109.23V109.191C130.695 106.304 132.864 103.934 135.965 103.934C137.868 103.934 139.009 104.565 139.96 105.501L138.552 107.146C137.772 106.438 136.973 105.998 135.965 105.998C134.253 105.998 133.035 107.413 133.035 109.153V109.191C133.035 110.931 134.234 112.384 135.965 112.384C137.126 112.384 137.83 111.925 138.629 111.199L140.036 112.633C138.99 113.742 137.849 114.449 135.889 114.449C132.921 114.449 130.695 112.136 130.695 109.23Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M141.711 104.125H143.937V108.561L148.046 104.125H150.729L146.619 108.427L150.919 114.277H148.255L145.116 109.956L143.956 111.18V114.277H141.73V104.125H141.711Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M156.835 104.125H160.964C163.38 104.125 164.826 105.559 164.826 107.643V107.681C164.826 110.033 162.999 111.256 160.735 111.256H159.042V114.296H156.816V104.144L156.835 104.125ZM160.812 109.249C161.915 109.249 162.581 108.58 162.581 107.719V107.681C162.581 106.687 161.896 106.152 160.774 106.152H159.061V109.249H160.831H160.812Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M166.25 109.23V109.191C166.25 106.304 168.514 103.934 171.634 103.934C174.754 103.934 176.999 106.266 176.999 109.153V109.191C176.999 112.078 174.735 114.449 171.615 114.449C168.495 114.449 166.25 112.117 166.25 109.23ZM174.678 109.23V109.191C174.678 107.452 173.403 105.998 171.615 105.998C169.827 105.998 168.59 107.413 168.59 109.153V109.191C168.59 110.931 169.865 112.384 171.653 112.384C173.441 112.384 174.678 110.969 174.678 109.23Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M179.148 104.125H181.374V114.277H179.148V104.125Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M184.172 104.125H186.227L190.964 110.377V104.125H193.151V114.277H191.268L186.379 107.815V114.277H184.191V104.125H184.172Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M198.195 106.19H195.113V104.125H203.484V106.19H200.402V114.296H198.176V106.19H198.195Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M205.595 105.521H205.348V104.354H204.91V104.125H206.052V104.354H205.614V105.521H205.595Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M207.095 105.177L206.657 104.527V105.521H206.41V104.125H206.676L207.095 104.794L207.514 104.125H207.78V105.521H207.533V104.507L207.095 105.177Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.3262 96.4953C95.7471 98.4837 92.8554 98.7896 90.8768 97.2027C88.8983 95.5967 88.5939 92.7097 90.1729 90.7213C91.752 88.7329 94.6437 88.427 96.6222 90.0139C98.6008 91.6008 98.9052 94.5069 97.3262 96.4953Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M91.1422 103.704C89.8675 104.296 88.3456 104.277 87.0519 103.532L83.4372 108.35C83.8938 108.885 84.1411 109.535 84.1602 110.223C84.1792 110.816 84.027 111.447 83.6845 111.982C82.7904 113.397 80.907 113.799 79.5182 112.881C79.366 112.785 79.2328 112.671 79.1186 112.556C79.0806 112.518 79.0425 112.479 79.0045 112.441C78.9284 112.346 78.8333 112.269 78.7762 112.174C78.7382 112.135 78.7001 112.097 78.6811 112.04C78.586 111.906 78.5099 111.772 78.4528 111.638C78.4528 111.6 78.4147 111.562 78.4147 111.524C78.3577 111.409 78.3196 111.294 78.2816 111.16C78.2816 111.122 78.2625 111.065 78.2435 111.026C78.2055 110.873 78.1864 110.721 78.1674 110.587C78.1674 110.548 78.1674 110.51 78.1674 110.472C78.1674 110.338 78.1674 110.204 78.1674 110.051C78.1674 110.032 78.1674 109.994 78.1674 109.975C78.1674 109.822 78.2245 109.65 78.2625 109.497C78.2625 109.459 78.2816 109.42 78.3006 109.382C78.3577 109.229 78.4147 109.057 78.4908 108.904L75.5801 106.706L74.6859 107.91L71.3566 105.405L73.8488 102.06L77.1781 104.564L76.284 105.769L79.2138 107.986C80.1269 107.222 81.4396 107.05 82.524 107.604L86.1197 102.805C84.6928 101.39 84.3314 99.1343 85.3777 97.318C85.587 96.9547 85.8343 96.6488 86.1197 96.362C84.1602 95.0237 81.8011 94.2398 79.2708 94.2207C72.5171 94.2207 67 99.727 67 106.514C67 113.302 72.441 118.827 79.2138 118.846C85.9675 118.846 91.4656 113.378 91.4846 106.572C91.4846 105.577 91.3705 104.622 91.1422 103.685V103.704Z",
					fill: "#ED135E"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_16421_141",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 165,
				height: 112,
				fill: "white",
				transform: "translate(67 89)"
			})
		}) })
	]
});
export default SvgBigLogoCp;
